import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input, OnDestroy,
} from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'pseic-form-checkbox',
  templateUrl: './pseic-form-checkbox.component.html',
  styleUrls: ['./pseic-form-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PseicFormCheckboxComponent implements AfterContentInit, OnDestroy {

  @Input() controlName: string;
  @Input() formGroup: UntypedFormGroup;
  @Input() resizeOnError = true;

  @HostBinding('class.pseic-form-checkbox') readonly pseicFormCheckboxClass = true;

  control: UntypedFormControl;
  required: boolean = false;

  private subs = new Subscription();

  constructor(private cd: ChangeDetectorRef) { }

  ngAfterContentInit(): void {
    this.control = this.formGroup.controls[this.controlName] as UntypedFormControl;
    this.refreshOnChanges(this.control, this.cd);
    this.required = this.checkIsValidatorRequiredExist();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private refreshOnChanges(formControl: UntypedFormControl, cd: ChangeDetectorRef): void {
    if (formControl) {
      this.subs.add(
        formControl.statusChanges.subscribe(_ => cd.markForCheck())
      );
      this.subs.add(
        formControl.valueChanges.subscribe(_ => cd.markForCheck())
      )
    }
  }

  private checkIsValidatorRequiredExist(): boolean {
    if (this.control && this.control.validator) {
      const validator = this.control.validator({} as AbstractControl);
      return  validator && validator.required;
    }
    return false;
  }
}
